import type { Airport } from '@/modules/Profile/types/model/airport'
import type {
  CarType,
  FlightClassOfService,
  HotelMealsIncluded,
  HotelRoomType,
  Passenger,
  SearchType,
} from '@/modules/Search/types'
import type { InterestCity } from '@/modules/Search/types/model/interestCity'

export enum SearchTravelMode {
  All = 'All',
  AirOnly = 'Aironly',
  HotelOnly = 'Hotelonly',
  CarRentalOnly = 'Carrentalonly',
  AirAndHotel = 'Airandhotel',
  AirAndCar = 'Airandcar',
  HotelAndCar = 'Hotelandcar',
  AirHotelAndCarRental = 'Airhotelandcarrental',
}

export interface SearchPassenger {
  type: Passenger
  age: number
}

export type SearchAirportGeoData = Pick<
  Airport | InterestCity,
  'geoLocation' | 'geoCity' | 'geoCountry'
>

export interface SearchOriginAndDestination {
  tag: string
  // FIXME: Should use the SearchAirportGeoData type for origin and destination
  origin: string
  destination: string
}

export interface SearchPayload {
  userId?: string
  searchId: string
  guestId?: string
  searchBy: SearchType
  travelMode: SearchTravelMode
  currency: string
  tags: Array<string>
  passengersWithRoom: Array<{ passengers: Passenger }>
  originAndDestinationList: Array<SearchOriginAndDestination>
  passengers: Array<SearchPassenger>
  language: string
}

interface SearchFlightPayloadOption {
  minimumClassOfService?: FlightClassOfService
  tag: string
  departureDate: string
  arrivalDate?: string
  departureTime: Array<string>
  arrivalTime: Array<string>
  bags: number | null
}

export interface SearchFlightPayload extends SearchPayload {
  flights: {
    flightType?: FlightClassOfService
    tripType: 'RoundTrip' | 'OneWay'
    bags: number | null
    options: Array<SearchFlightPayloadOption>
  }
  flightPageSize: number
  residency?: string
}

export interface SearchHotelPayloadOption {
  tag: string
  checkInTime?: string
  checkOutTime?: string
  checkInDate?: string
  checkOutDate?: string
  location?: string | null
}

export interface SearchHotelPayloadRoom {
  adults: Array<number>
  children: Array<number>
}

export interface SearchHotelPayload extends SearchPayload {
  hotels: {
    roomType?: HotelRoomType
    starRatingMinimum?: number
    radiusInKilometers?: number
    mealsIncluded?: HotelMealsIncluded
    options: Array<SearchHotelPayloadOption>
  }
  hotelPageSize?: number | null
  residency?: string
}

export interface SearchCarPayloadOption {
  tag: string
  carType?: CarType
  pickUpDate?: string
  dropOffDate?: string
}

export interface SearchCarPayload extends SearchPayload {
  cars: Array<SearchCarPayloadOption>
  carPageSize: number
  residency?: string
}
